export default {"src":"/_next/static/image/public/images/flags/flag_250.6e93f7ad8af806f00ffc14388fca57c7.svg","height":16,"width":24};